export const LOGOUT_USER_REQUEST = 'app/services/auth/LOGOUT_USER_REQUEST';


export const PERMISSIONS = {
    VIEW_ORGANIZATION: 'VIEW_ORGANIZATION',
    VIEW_EMPLOYEES_IN_ORGANIZATION: 'VIEW_EMPLOYEES_IN_ORGANIZATION',
    VIEW_EMPLOYEES_IN_SAME_TEAM: 'VIEW_EMPLOYEES_IN_SAME_TEAM',
    VIEW_DIRECT_REPORTS: 'VIEW_DIRECT_REPORTS',
    VIEW_MANAGER: 'VIEW_MANAGER',
    VIEW_TEAMS_IN_ORGANIZATION: 'VIEW_TEAMS_IN_ORGANIZATION',
    VIEW_OFFICES_IN_ORGANIZATION: 'VIEW_OFFICES_IN_ORGANIZATION',
    VIEW_DEPARTMENTS_IN_ORGANIZATION: 'VIEW_DEPARTMENTS_IN_ORGANIZATION',
    VIEW_OWN_INFORMATION: 'VIEW_OWN_INFORMATION',
    EDIT_OWN_INFORMATION: 'EDIT_OWN_INFORMATION',
    MANAGE_ORGANIZATION_STRUCTURE: 'MANAGE_ORGANIZATION_STRUCTURE',
    IMPERSONATE_EMPLOYEES: 'IMPERSONATE_EMPLOYEES',
    MANAGE_REVIEW_EVENTS_FOR_ORGANIZATION: 'MANAGE_REVIEW_EVENTS_FOR_ORGANIZATION',
    MANAGE_DEVELOPMENT_TALKS_FOR_ORGANIZATION: 'MANAGE_DEVELOPMENT_TALKS_FOR_ORGANIZATION',
    MANAGE_GOALS_FOR_ORGANIZATION: 'MANAGE_GOALS_FOR_ORGANIZATION',
    VIEW_ALL_REVIEW_EVENTS_IN_ORGANIZATION: 'VIEW_ALL_REVIEW_EVENTS_IN_ORGANIZATION',
    VIEW_PUBLISHED_REVIEW_EVENTS_IN_ORGANIZATION: 'VIEW_PUBLISHED_REVIEW_EVENTS_IN_ORGANIZATION',
    VIEW_ALL_DEVELOPMENT_TALKS_IN_ORGANIZATION: 'VIEW_ALL_DEVELOPMENT_TALKS_IN_ORGANIZATION',
    VIEW_ALL_GOALS_IN_ORGANIZATION: 'VIEW_ALL_GOALS_IN_ORGANIZATION',
    VIEW_ALL_REVIEW_EVENT_RESULTS_IN_ORGANIZATION: 'VIEW_ALL_REVIEW_EVENT_RESULTS_IN_ORGANIZATION',
    VIEW_GOALS_FOR_DIRECT_REPORTS: 'VIEW_GOALS_FOR_DIRECT_REPORTS',
    VIEW_DEVELOPMENT_TALKS_FOR_DIRECT_REPORTS: 'VIEW_DEVELOPMENT_TALKS_FOR_DIRECT_REPORTS',
    VIEW_REVIEW_EVENT_RESULTS_FOR_DIRECT_REPORTS: 'VIEW_REVIEW_EVENT_RESULTS_FOR_DIRECT_REPORTS',
    MANAGE_JOB_POSITIONS_FOR_ORGANIZATION: 'MANAGE_JOB_POSITIONS_FOR_ORGANIZATION',
    MANAGE_JOB_POSITIONS_WHEN_INVOLVED_IN_POSITION: 'MANAGE_JOB_POSITIONS_WHEN_INVOLVED_IN_POSITION'
};

export const DEFAULT_REDIRECT = '/o';

export const ALVA_TOKEN_KEY = 'alva:token';
export const ALVA_SELECTED_ORGANIZATION_KEY = 'alva:selected_organization';
export const ALVA_IMPERSONATION_TOKEN_KEY = 'alva:impersonation_token';
